import { render, staticRenderFns } from "./transport.vue?vue&type=template&id=6624c87c&scoped=true&"
import script from "./transport.vue?vue&type=script&lang=js&"
export * from "./transport.vue?vue&type=script&lang=js&"
import style0 from "./transport.vue?vue&type=style&index=0&id=6624c87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624c87c",
  null
  
)

export default component.exports